import { useButtonGroupContext } from 'components/buttonGroup/ButtonGroupContext';
import { useTabListContext } from 'components/tabList/TabListContext';

export enum SourceType {
  PERSONA = 'persona',
  UNIVERSE = 'universe',
  SCENE = 'scene',
}

export enum AssetScope {
  MY = 'my',
  ENTIRE = 'entire',
}

type AssetType = {
  sourceType: SourceType;
  assetScope: AssetScope;
};
export const useRankContext = () => {
  const { activateTabItem } = useTabListContext();
  const { activateButtonItem } = useButtonGroupContext();

  return {
    assetScope: activateTabItem?.type || AssetScope.MY,
    sourceType: activateButtonItem?.type || SourceType.PERSONA,
  } as AssetType;
};
